import { useOrganizerSitesQuery } from './generated'

export function useSites() {
  const [result] = useOrganizerSitesQuery();
  const sites = result.data?.user?.sites;

  return { sites, loading: result.fetching };
}
